var map = {
	"./address.svg": "e8fc",
	"./email.svg": "43be",
	"./last-name.svg": "8f0a",
	"./location.svg": "d2eb",
	"./no-preview-aye.svg": "72a4",
	"./phone-call.svg": "c251",
	"./phone.svg": "c3bb",
	"./preview-aye.svg": "58d3",
	"./second-name.svg": "aa46",
	"./user-account.svg": "354c",
	"./user-avatar.svg": "b7fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";